// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Webcam from "react-webcam";
import Button from "@material-ui/core/Button";
import AddAPhotoIcon from "@material-ui/icons/AddAPhoto";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../types/GeneralTypes";
import type { ButtonStylesClassesType } from "../../styles/buttonStyles";
import type { IconStylesClassesType } from "../../styles/iconStyles";
import { buttonStyles } from "../../styles/buttonStyles";
import { iconStyles } from "../../styles/iconStyles";
import CancelButton from "../ButtonIcons/CancelButton";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...buttonStyles(theme),
  ...iconStyles(theme),
  rightMargin: {
    marginRight: "10px"
  },
  halfRightMargin: {
    marginRight: "5px"
  }
});

type WebCameraClassesType = {
  ...ButtonStylesClassesType,
  ...IconStylesClassesType,
  rightMargin: DictionaryType,
  halfRightMargin: DictionaryType
};

type WebCameraPropsType = {
  classes: WebCameraClassesType,
  captureCamera: Function,
  cancelCamera: Function,
  setError: Function
};

class WebCamera extends Component<WebCameraPropsType, *> {
  webcam: *;
  setRef: *;
  constructor(props: WebCameraPropsType) {
    super(props);
    this.webcam = null;

    this.setRef = (element: *) => {
      this.webcam = element;
    };
  }

  capture = () => {
    const imageSrc = this.webcam && this.webcam.getScreenshot();
    this.props.captureCamera(imageSrc);
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    return (
      <div>
        <Webcam
          audio={false}
          ref={this.setRef}
          screenshotFormat="image/jpeg"
          style={{ width: "100%", height: "100%" }}
          onUserMediaError={this.props.setError}
        />
        <Button
          color="primary"
          variant="contained"
          type="submit"
          onClick={this.capture}
          className={classNames(classes.darkBtn, classes.rightMargin)}
        >
          <AddAPhotoIcon
            className={classNames(classes.lightIcon, classes.halfRightMargin)}
          />
          Capture Photo
        </Button>
        <CancelButton onClick={this.props.cancelCamera} />
      </div>
    );
  }
}

export default withStyles(styles)(WebCamera);
